/*
 * @Author       : lubiao01
 * @File         : ubc打点
 * @Date         : 2023-03-07 19:30:41
 */
import boxx from '@baidu/boxx-fe';
import {UbcLogger} from '@baidu/ubc-report-sdk';
import {
    APP_MODE,
    LOG_ID_MAP,
    PAGE_FROM,
} from '@src/lib/constants';
import {md5} from 'js-md5';
import {merge} from 'lodash-es';
import {
    PAGE_TYPE,
    PAGE_TYPE_LOG,
} from '../constants';
import __INSTANCE__ from '../InstanceManager';
import {
    browserName,
    isPcClient,
} from '../utils/env';
import {
    getNetworkStatus,
    pcClientCanIUse,
} from '../utils/native';
import {
    dealBase64,
    getKeyCommonParams,
    inNewApp,
    isEmpty,
} from '../utils/tools';

let cfrom = '';
let from = '';
let appUa = '';
let ut = '';
let sid = '';
let appmode = '';

const {boxVersion} = boxx.env;

const LOG_RECORDS = new Map<string, boolean>();

const getAppVersion  = () => {
    if (isPcClient()) {
        return window.clientCommonParams?.app_version || '';
    }
    else if (inNewApp) {
        return boxVersion;
    }
    return 'h5';
};
// 获取cookie中的某个key
const getCookieValue = (name: string): string | null => {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
        const [
            key,
            value,
        ] = cookie.split('=');
        if (key === name) {
            return decodeURIComponent(value);
        }
    }
    return null;
};
const appLayout = window.globalData?.globalSettings?.appLayout || getCookieValue('appLayout') || '';

class UbcLog {
    ubcId: string;
    configs: {
        [key: string]: string | boolean;
    };
    ubcInstance: any;
    constructor({configs = {}, ubcId = ''}) {
        const appName = isPcClient() ? 'xiaoyan_pc' : 'new_app';
        this.ubcId = ubcId;
        this.configs = {
            from: appName,
            page: '',
            source: 'default',
            testMode: process.env.NODE_ENV !== 'production',
            ...configs,
        };

        // ssr环境不init
        // @ts-ignore
        if (!import.meta.env.SSR) {
            if (inNewApp) {
                cfrom = getKeyCommonParams('cfrom');
                from = getKeyCommonParams('from');
                appUa = getKeyCommonParams('ua');
                ut = getKeyCommonParams('ut');
                sid = getKeyCommonParams('sid');
                appmode = getKeyCommonParams('appmode');
            }
            if (isPcClient()) {
                appUa = window.clientCommonParams?.ua || '';
            }
            this.ubcInstance = new UbcLogger({
                serverId: this.ubcId,
                ...this.configs,
                queryParams: {
                    appname: 'newapp',
                    cfrom,
                    from,
                    ut,
                    ua: appUa,
                    sid,
                    appmode,
                },
            });
        }
    }

    send({params = {}, ext = {}}) {
        try {
            const newParams = Object.assign({}, this.configs, params);
            const {type, value, page, source, forCase} = newParams;
            const finalPage = !forCase && !inNewApp && window.liteChatInfo
                ? window.liteChatInfo.page : page;
            const select = localStorage.getItem('APP_MODE') as keyof typeof APP_MODE;
            this.ubcInstance.send({
                type,
                value,
                page: finalPage,
                source: source || this.configs.source,
                ext: {
                    ...ext,
                    fromH5: 1,
                    page: inNewApp ? null : 'h5',
                    browser: inNewApp ? null : browserName,
                    appmode: APP_MODE[select] || '',
                    appLayout,
                },
            });
        }
        catch (e) {
            console.error(`${this.ubcId}.打点错误`, e);
        }
    }
}

const ubcLog = (data: Record<string, any>, options: Record<string, unknown> = {}) => {
    if (__INSTANCE__.config.log === false) {
        return;
    }
    const sign = md5(JSON.stringify(data)); // data 签名
    const {params = {}, ext = {}, ubcId = '6327'} = data;
    const {
        params: gParams = {},
        ext: gExt = {},
        ubcId: gUbcId = '',
    } = typeof __INSTANCE__.config.log === 'object'
        ? __INSTANCE__.config.log
        : {};
    const isShowLog = params.type === 'show';

    // 语聊会话记录页单独修改page
    if (__INSTANCE__.store?.get('pageFrom') === PAGE_FROM.PHONE_CALL) {
        params.page = 'voice_chat_content';
    }

    if (params.page === PAGE_TYPE_LOG[PAGE_TYPE.VIDEO]) {
        params.source = 'landingpage_video';
    }

    if (isShowLog) {
        const {once = true} = options; // 是否只打一次

        if (once && LOG_RECORDS.has(sign)) {
            return;
        }

        LOG_RECORDS.set(sign, true);
    }

    try {
        const loger = new UbcLog({
            ubcId: gUbcId || ubcId,
        });
        let newLoger: UbcLog | null = null;
        if (LOG_ID_MAP[loger.ubcId]) {
            const newUbcId = LOG_ID_MAP[loger.ubcId];
            newLoger = new UbcLog({
                ubcId: newUbcId,
            });
        }
        loger.send({
            params: merge(params, gParams),
            ext: merge({
                'app_version': getAppVersion(),
                'is_vip': '1',
            }, ext, gExt),
        });
        newLoger && newLoger.send({
            params: merge(params, gParams),
            ext: merge({
                'app_version': getAppVersion(),
                'is_vip': '1',
            }, ext, gExt),
        });
    }
    catch (e) {
        console.error(e);
    }
};

interface CaseUbcLogParams {
    coreResult?: string;
    msg?: string;
    opName?: string;
}

// 研发打点，借用端6570点位，所以字段结构有要求，不能随意修改
// https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/qCCPuIpbfn/2bDtTCu3yf/aae3c40024954f
const caseUBCLog = (logData: CaseUbcLogParams) => {
    // 暂时先写死，后续迭代调整
    const params = {
        from: 'talk',
        type: 'h5_request',
        value: '',
        page: 'other',
        source: '',
        // 标识，send时不替换page
        forCase: '1',
    };
    try {
        const appName = isPcClient() ? 'xiaoyan_pc' : 'new_app';
        const loger = new UbcLog({
            ubcId: '6570',
            configs: {
                from: params.from || appName,
            },
        });
        loger.send({
            params,
            ext: merge({
                'app_version': getAppVersion(),
            }, {
                'core_result': logData?.coreResult || '1',
                traces: [
                    {
                        logid: '',
                        'op_name': logData?.opName || 'h5_log',
                        'net_code': '',
                        'net_msg': logData?.msg,
                        errno: '',
                        errmsg: '',
                        duration: 0,
                    },
                ],
            }),
        });
    }
    catch (e) {
        console.error(e);
    }
};

/**
 * @description 通过端发送yalog日志
 * @description http://es.baidu-int.com/#/apidetail/2260/base
 * @description yalog接口文档 - http://es.baidu-int.com/#
 * @param tag 日志标签
 * @param message 日志内容
 * @param level 等级
 * @param logId 日志id
 */
const sendYaLog = async (message: string, type = '', tag = 'newapp', level?: string, logId?: string) => {

    const send = (message: string) => {
        message += `_ts=${Date.now()}_webviewId=${window?.webviewId}_hostTag=${window.globalData?.hostTag}_fromH5`;

        if (boxx.canIUse('newapp.utils.reportYalog')) {
            boxx.newapp.utils.reportYalog({
                tag,
                message,
                level,
                logId,
                // debug时可以解开注释，success为调用端能力成功回调，fail为调用端能力失败回调
                // success: res => {
                //     console.log(res);
                // },
                // fail: res => {
                //     console.log(res);
                // },
            });
        }
        else if (pcClientCanIUse('native:utils-reportYalog')) {
            window.native.send('native:utils-reportYalog', {
                tag,
                message,
                level,
                logId,
            });
        }
        // else if (window.liteChatInfo) {
        //     caseUBCLog({
        //         msg: message,
        //     });
        // }
        else {
            // console.error('newapp.utils.reportYalog 端能力不存在！！！');
        }
    };

    if (type === 'net') {
        getNetworkStatus()
            .then(({networkType}) => {
                message += `_net=${networkType}`;
                send(message);
            })
            .catch(console.error);
    }
    else {
        send(message);
    }
};

// 获取对话页打点page值
const getChatLogPage = (hostTag?: string) => {
    const curHostTag = (hostTag || window.globalData?.hostTag) as PAGE_TYPE;
    return PAGE_TYPE_LOG[curHostTag] || PAGE_TYPE_LOG[PAGE_TYPE.MAIN];
};
class StabilityLog {
    private traceData?: Record<string, any> | null;
    private startTime: number | null;
    private logData: Record<string, any> | null;
    constructor() {
        this.traceData = null;
        this.startTime = null;
        this.logData = null;
    }
    collectLogData(data?: Record<string, any>) {
        if (this.traceData && data && !isEmpty(data)) {
            this.logData = {
                ...this.logData,
                ...data,
            };
        }
    }
    setTraceData(data?: Record<string, any>) {
        // data && 为了过eslint
        if (data && !isEmpty(data)) {
            this.startTime = Date.now();
            this.traceData = data;
            // 手动兜底na没下发startTime的情况
            if (!this.traceData?.ext?.startTime && this.traceData?.ext) {
                this.traceData.ext.startTime = Date.now();
            }
        }
    }

    updateTraceData(data: any, updateType: 'partial' | 'full' = 'partial') {
        if (isEmpty(this.traceData) || isEmpty(data)) {
            return;
        }
        if (updateType === 'full' && data?.ext?.log_id === this.traceData?.ext?.log_id) {
            this.setTraceData(data);
        }
        else {
            this.collectTraceData(data);
        }
    }
    private collectTraceData(data: {
        log: Record<string, any>;
        srv: Record<string, any>;
        duration?: number;
    }) {
        const {log, srv, duration, ...params} = data || {};
        const feLog = this.completionLog.log ?? {};
        // 局部更新
        if (!isEmpty(feLog)) {
            Object.assign(feLog, params);
        }
        else {
            this.traceData?.ext?.spans?.push({
                op: 'completion',
                duration: duration || Date.now() - (this.startTime || 0),
                network: navigator?.connection?.effectiveType,
                log,
                srv,
            });
        }
    }

    sendLog() {
        const {ext, ...traceDataParams} = this.traceData || {};
        if (isEmpty(traceDataParams)) {
            return;
        }
        const dealExtData = () => {
            // 端上没给errorno,用前端的
            // 本次错误码：200 成功、202 弱依赖有损(大盘不记损)、403 风控拒绝（大盘不记损）、500 对话失败，大盘记损。
            const serverLog = this.completionLog?.srv ?? {};
            const feLog = this.completionLog?.log ?? {};
            // 前端span-主动中断算200
            this.completionLog.errno = [
                0,
                200,
            ].includes(feLog?.stop) ? 200 : feLog.stop;
            Object.assign(feLog, this.logData);
            const isFile = !isEmpty(feLog?.chatFileInfo);
            delete feLog.chatFileInfo;
            // 处理value
            if (window.globalData?.hostTag === PAGE_TYPE.MULTI_MODE) {
                traceDataParams.value = 'image';
            }
            else if (isFile) {
                traceDataParams.value = 'file';
            }

            if (!ext?.errno || serverLog?.errno !== 200) {
                // const feLog = this.completionLog?.log ?? {};
                let errno = 200;
                if (serverLog?.errno === 410) {
                    errno = 403;
                }
                else if (serverLog?.errno !== 200) {
                    errno = 500;
                }
                // 202先保留，目前没有
                // else if (feLog?.stop) {
                //     errno = 202;
                // }
                else {
                    errno = 200;
                }
                ext.errno = errno;
            }
            // 直至前端打字输出完毕
            ext.duration = Date.now() - ext?.startTime;
            ext.query = dealBase64(ext?.query) || '';
        };
        dealExtData();
        ubcLog({
            ubcId: '19045',
            params: traceDataParams,
            ext,
        });
        // console.log(
        //     'ubcLog>>>>>>',
        //     {
        //         ubcId: '19045',
        //         params: traceDataParams,
        //         ext,
        //     }
        // );
        // 发送完日志清空traceData，释放内存
        this.traceData = null;
    }

    get completionLog() {
        return this.traceData?.ext?.spans?.find((item: any) => item?.op === 'completion') || {};
    }
}
const stabilityLog = new StabilityLog();
export {
    caseUBCLog,
    getChatLogPage,
    sendYaLog,
    stabilityLog,
    ubcLog,
};
